import * as React from 'react'
import { Link } from 'gatsby'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'

export default function Navbar() {

  const activeStyle = {
    backgroundColor: 'hsl(32, 100%, 51%)'
  }

  return (
    <nav>
      <ul className="secciones">
        <Link to="/" activeStyle={activeStyle} id="home">
          <FontAwesomeIcon icon={faHome} size='1x'/>
        </Link>
        <Link to="/proyectos" activeStyle={activeStyle}>Proyectos</Link>
        <Link to="/competencias" activeStyle={activeStyle}>Competencias</Link>
        <Link to="/blogs" activeStyle={activeStyle}>Blog</Link>
        <Link to="/about" activeStyle={activeStyle}>Sobre mí</Link>
      </ul>
    </nav>
  )

}


